import { EventBus } from '@/shared/app/connector/EventBus';

/**
 * Initialize dishes rotation
 * @param interval - Interval between dishes rotation in milliseconds (default: 6600)
 */
export const initDishesRotation = (interval = 6600) => {
  return setInterval(() => {
    EventBus.$emit('dishes_rotation');
  }, interval);
};
